import Vue from 'vue';
import App from './app/App.vue';
import { router } from './router';
import { store } from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// import RouterTab and styles
import RouterTab from 'vue-router-tab';
import 'vue-router-tab/dist/lib/vue-router-tab.css';

Vue.config.productionTip = false;
Vue.use(RouterTab);

library.add(fas);
library.add(far);
Vue.component('font-awesome-icon', FontAwesomeIcon);

import moment from 'moment';
Vue.prototype.moment = moment;

var numeral = require('numeral');
numeral.zeroFormat('0');
numeral.localeData('en').currency.symbol = '£';

Vue.filter('formatCurrency', function(value) {
  return value == 0 ? '£0' : numeral(value).format('($0,0.00)');
});

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
Vue.component('vue-timepicker', VueTimepicker);

window.axios = require('axios');
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    store.dispatch('alert/error', error.response);
    return Promise.reject(error);
  }
);

import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib'; //Globally import VTextField

Vue.component('v-text-field', VTextField);
Vue.use(VCurrencyField, {
  decimalLength: 2,
  autoDecimalMode: false,
  defaultValue: 0,
});

import actionForm from '@/components/action.vue';
import newTextForm from '@/components/newText.vue';
import popupForm from '@/components/popup.vue';
import page from '@/components/page.vue';
import sidebarPage from '@/components/page.vue';
import numberInput from '@/components/numberInput.vue';

Vue.component('action-form', actionForm);
Vue.component('new-text-form', newTextForm);
Vue.component('popup-form', popupForm);
Vue.component('page', page);
Vue.component('page', sidebarPage);
Vue.component('number-input', numberInput);

Array.prototype.last = function() {
  return this[this.length - 1];
};

String.prototype.empty = function() {
  return this != null && this != '' && this != undefined;
};

String.prototype.toUpper = function() {
  return this.toLowerCase().replace(/^\w|\s\w/g, function(letter) {
    return letter.toUpperCase();
  });
};

String.prototype.toUpperFirstLetter = function() {
  return this.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1);
  });
};

String.prototype.params = function(obj) {
  var params = [];
  var url = this;
  if (obj) {
    Object.keys(obj).forEach((k) => {
      if (obj[k] != null && obj[k] != undefined && obj[k] != '') {
        params.push(`${k}=${obj[k]}`);
      }
    });
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
  }
  return url;
};

Vue.mixin({
  methods: {
    validObj(obj, props) {
      var exists = true;
      if (!obj) {
        return true;
      }
      var keys = Object.keys(obj);
      props.forEach(function(prop) {
        if (!keys.includes(prop)) {
          exists = false;
        } else {
          if (
            obj[prop] === null ||
            obj[prop] === '' ||
            obj[prop] === undefined
          ) {
            exists = false;
          }
        }
      });
      return exists;
    },
    cleanObj(obj, ignore) {
      var ig = ['comments'];
      if (ignore != null) {
        ig = ig.concat(ignore);
      }
      Object.keys(obj).forEach((key) => {
        var prop = obj[key];
        if (typeof prop === 'string' || prop instanceof String) {
          if (!ig.includes(key)) {
            obj[key] = prop.toUpperFirstLetter();
          }
        } else if (Array.isArray(prop)) {
          prop.forEach((prop1) => {
            if (typeof prop1 === 'string' || prop1 instanceof String) {
              if (!ig.includes(key)) {
                prop1 = prop1.toUpperFirstLetter();
              }
            } else {
              this.cleanObj(prop1);
            }
          });
        }
      });
    },
    canAddToArray(arr, props) {
      if (!arr) {
        return true;
      } else {
        var last = arr.last();
        return this.validObj(last, props);
      }
    },
    isEmptyArray(arr) {
      if (!arr) {
        return true;
      } else {
        return arr.length > 0;
      }
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
